import { FormTextField } from '@elements/Inputs'
import { Section } from './SharedFormComponents'

const SocialFormSection = ({ state, handleSocialChange }) => {
  return (
    <Section>
      <FormTextField
        name='displayName'
        label='Display Name'
        placeholder='Name for social display'
        value={state?.displayName}
        onChange={handleSocialChange}
      />
      <FormTextField
        name='bio'
        label='Bio'
        placeholder='Tell us about yourself.'
        value={state?.bio}
        onChange={handleSocialChange}
        multiline
        rows={4}
      />
      <FormTextField
        name='homeLocation'
        label='Home Location'
        placeholder='New York, Berlin, etc.'
        value={state?.homeLocation}
        onChange={handleSocialChange}
      />
    </Section>
  )
}

export { SocialFormSection }
